import { withRouter } from "react-router-dom"
import React, { useState, useEffect } from "react";
import TextField from '@material-ui/core/TextField';
import { useStyles } from "../components/MainTheme.js";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button } from 'antd';
import Grid from '@material-ui/core/Grid';


function UpdateCategory(props) {

    const category_id = props.category_id
    const open = props.open

    const classes = useStyles();

    const [category, setCategory] = useState(null);
    const [loading, setLoading] = useState(false);

    const [errorName, setErrorName] = useState(false);

    useEffect(() => {
        getData()
    }, [open, category_id])

    async function getData() {

        await fetch(`${process.env.REACT_APP_API_BASE_URL}/getCategory/${category_id}`).then(
            response => response.json()).then(
                json => setCategory(json)
            )

    }

    async function update() {

        setLoading(true)

        if (category === '') {
            setErrorName(true)
            setLoading(false)
        } else {

            const formData = new FormData();

            formData.append('category', category)
            formData.append('category_id', category_id)

            await fetch(`${process.env.REACT_APP_API_BASE_URL}/updateCategory`, {
                method: "POST",
                body: formData
            }).then(
                response => response.json()).then(
                    json => {
                        if (json.result === 'success') {
                            handleClose()
                        }
                        else {
                            setLoading(false)
                        }
                    }

                )
        }


    }

    const handleClose = () => {
        setCategory(null)
        setErrorName(false)
        setLoading(false)
        props.category_id_clear(null)
        props.close(false)
    };

    return category_id ? (

        <Dialog fullWidth disableBackdropClick disableEscapeKeyDown open={open} onClose={handleClose}>
            <DialogTitle>Modifica categoria</DialogTitle>

            <DialogContent>
                <Grid item xs={12} sm={12} lg={12}>
                    <TextField
                        fullWidth
                        id="outlined-full-width"
                        label="Nome categoria"
                        placeholder="Nome categoria"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        size='small'
                        variant="outlined"
                        required
                        defaultValue={category}
                        onChange={(e) => setCategory(e.target.value)}
                        error={errorName}
                        helperText={errorName ? 'Il campo è obbligatorio' : null}
                    />
                </Grid>


            </DialogContent>
            <DialogActions>
                <Button disabled={loading} onClick={handleClose} >
                    Cancella
                </Button>
                <Button
                    loading={loading}
                    form="my-form-id"
                    type="primary"
                    className={classes.button}
                    onClick={update} >
                    Salva
                </Button>
            </DialogActions>
        </Dialog>
    ) : null


}

export default withRouter(UpdateCategory);
